import axios from 'axios'
import { push } from 'connected-react-router'
import {LOGOUT, SHOW_WARNING} from './auth'

export const QUESTIONS = 'questions/QUESTIONS'
export const QUESTION = 'questions/QUESTION'
export const ANSWER = 'questions/ANSWER'
export const DOWNLOAD_TIME = 'questions/DOWNLOAD_TIME'
export const ANSWER_INVALID = 'questions/ANSWER_INVALID'

let initialState = {
	isRequestingData: false,
	questions: [],
	currentQuestion: {}
}

export default (state = initialState, action) => {
	switch (action.type) {
		case ANSWER_INVALID:
			return {
				...state,
				currentQuestion: {
					...state.currentQuestion,
					answerInvalid: action.payload
				}
			}
		case QUESTIONS:
			return {
				...state,
				questions: action.payload
			}
		case QUESTION:
			return {
				...state,
				currentQuestion: action.payload
			}
		case DOWNLOAD_TIME:
			return {
				...state,
				currentQuestion: {
					...state.currentQuestion,
					downloadTime: action.payload.date,
					downloadTimeParsed: action.payload.parsed
				}
			}
		case LOGOUT:
			return {...initialState}
		default:
			return state
	}
}

export const getAllQuestions = () => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		if(token) {
			if(!getState().auth.user.Active){
				dispatch(push('/activation'));
			}

			axios.get('https://incident-response-challenge.com/middleware/all-questions', {
					headers: {
						'Authorization': 'Bearer ' + token
					}
				}
			).then((response) => {
				dispatch({
					type: QUESTIONS,
					payload: response.data
				})
			})
		}
	}
}

const moment = require('moment');

const duration = (t0, t1) => {
	var day = new Date();
	var now = moment.utc(day.toUTCString());
	var then = moment.utc(t0);

	let d = now.diff(then)

	let weekdays     = Math.floor(d/1000/60/60/24/7);
	let days         = Math.floor(d/1000/60/60/24 - weekdays*7);
	let hours        = Math.floor(d/1000/60/60    - weekdays*7*24            - days*24);
	let minutes      = Math.floor(d/1000/60       - weekdays*7*24*60         - days*24*60         - hours*60);
	let seconds      = Math.floor(d/1000          - weekdays*7*24*60*60      - days*24*60*60      - hours*60*60      - minutes*60);

	return {hours, minutes, seconds};
}

export const getDownloadTime = (download_id) => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		if(token) {
			return axios.get('https://incident-response-challenge.com/middleware/download-time', {
					headers: {
						'Authorization': 'Bearer ' + token
					},
					params: {
						'question_id': getState().questions.currentQuestion.Id
					}
				}
			).then((response) => {
				if(response.data !== 0) {
					dispatch({
						type: DOWNLOAD_TIME,
						payload: {date: response.data.date, parsed: duration(response.data.date)}
					})
				}
			})
		}
	}
}

export const clearCurrentQuestion = () => {
	return dispatch => {
		dispatch({
			type: QUESTION,
			payload: {}
		})
	}
}

export const downloadFile = (download_id) => {
	return (dispatch, getState) => {
		const token = getState().auth.token;

		if(token) {
			axios.get('https://incident-response-challenge.com/middleware/download', {
					headers: {
						'Authorization': 'Bearer ' + token
					},
					params: {
						'question_id': getState().questions.currentQuestion.Id,
						download_id
					}
				}
			).then((response) => {
				setTimeout(() => {
					dispatch(getDownloadTime())
				}, 1000);
				window.open('https://incident-response-challenge.com/middleware/downloads/' + response.data.url);
			})
		}
	}
}

export const getQuestion = (question_id) => {
	return (dispatch, getState) => {
		if(question_id !== 1 && Object.keys(getState().auth.user).length){
			if(!getState().auth.user.Active){
				dispatch(push('/activation'));
			}
		}

		const token = getState().auth.token;

		if(token) {
			axios.get('https://incident-response-challenge.com/middleware/questions?question_id=' + question_id, {
				headers: {
					'Authorization': 'Bearer ' + token
				}
			}).then((response) => {
				if(response.data.Completed){
					dispatch(push('/'));
				}
				else {
					dispatch({
						type: QUESTION,
						payload: response.data
					})

					if(response.data.WarningContent){
						dispatch({
							type: SHOW_WARNING
						})
					}

					dispatch(getDownloadTime());
				}
			})
		}
		else {
			axios.get('https://incident-response-challenge.com/middleware/example-questions?question_id=' + question_id).then((response) => {
				dispatch({
					type: QUESTION,
					payload: response.data
				})
			})
		}
	}
}

export const submitAnswer = () => {
	return (dispatch, getState) => {
		const token = getState().auth.token;
console.log('asdasd');
		dispatch({
			type: ANSWER_INVALID,
			payload: false
		})

		if(token) {
			axios.post('https://incident-response-challenge.com/middleware/answer', {
					question: getState().questions.currentQuestion.Id,
					answer: getState().questions.currentQuestion.Answers
				}, {
					headers: {
						'Authorization': 'Bearer ' + token
					}
				}
			).then((response) => {
				if(response.data.valid) {
					dispatch({
						type: QUESTION,
						payload: {}
					})
					dispatch(push('/'));
				}
				else {
					dispatch({
						type: ANSWER_INVALID,
						payload: true
					})
				}
			})
		}
	}
}